/**
 * @generated SignedSource<<cc9eb35d89d30895e840bbf83552152d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePoiInput = {
  description?: string | null;
  name?: string | null;
};
export type PoiEditFormMutation$variables = {
  id: string;
  input: UpdatePoiInput;
};
export type PoiEditFormMutation$data = {
  readonly updatePoi: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "PoiEditForm_poi">;
  } | null;
};
export type PoiEditFormMutation = {
  response: PoiEditFormMutation$data;
  variables: PoiEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PoiEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Poi",
        "kind": "LinkedField",
        "name": "updatePoi",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PoiEditForm_poi"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PoiEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Poi",
        "kind": "LinkedField",
        "name": "updatePoi",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "750461fbc5748426a4e366ea4678fbeb",
    "id": null,
    "metadata": {},
    "name": "PoiEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation PoiEditFormMutation(\n  $id: ID!\n  $input: UpdatePoiInput!\n) {\n  updatePoi(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...PoiEditForm_poi\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment PoiEditForm_poi on Poi {\n  id\n  name\n  description\n}\n"
  }
};
})();

(node as any).hash = "1fef281cceca4a2682c5aa4417538ecc";

export default node;
